// https://github.homeawaycorp.com/hacommons/hacommons-i18n/blob/master/src/main/resources/com/homeaway/commons/i18n/formatter/i18nCurrencySymbols.properties
const CORRECTED_CURRENCY_SYMBOLS = require('./data/currency/symbols.json');
const CURRENCY_PRECISIONS = require('./data/currency/precisions.json');


/**
 * Resolves a single currency symbol based on currency code and locale
 *
 * @param currencyCode the currency code for the currency you wish to add (eg 'USD', 'AUD', 'GBP')
 * @param locale the locale to determine the format of the result (eg 'en', 'en_US' or 'en_US_HA', defaults to 'en_US')
 * @returns currency symbol based on ISO 4217 Currency Code.
 */
const getCorrectedCurrencySymbol = (currencyCode, locale = 'en_US') => {
    const country = locale.split('_')[1];
    return CORRECTED_CURRENCY_SYMBOLS.hasOwnProperty(country) ? (CORRECTED_CURRENCY_SYMBOLS[country].symbols[currencyCode] || CORRECTED_CURRENCY_SYMBOLS.DEFAULT.symbols[currencyCode]) : CORRECTED_CURRENCY_SYMBOLS.DEFAULT.symbols[currencyCode];
};

/**
 * Returns all corrected currency symbols consolidated based on locale
 *
 * @param locale the locale to determine the format of the result (eg 'en', 'en_US' or 'en_US_HA', defaults to 'en_US')
 * @returns all consolidated currency symbols.
 */
const getConsolidatedCurrencySymbols = (locale = 'en_US') => {
    const country = locale.split('_')[1];
    return CORRECTED_CURRENCY_SYMBOLS.hasOwnProperty(country) ? Object.assign({}, CORRECTED_CURRENCY_SYMBOLS.DEFAULT.symbols, CORRECTED_CURRENCY_SYMBOLS[country].symbols) : CORRECTED_CURRENCY_SYMBOLS.DEFAULT.symbols;
};

// Use HomeAway specific currency symbols instead of the international standard (eg AU$ instead of $)
const replaceWithHomeAwayCurrencySymbol = (formattedNumber, currency, locale) => {
    const correctedCurrency = getCorrectedCurrencySymbol(currency, locale);
    if (!correctedCurrency) {
        return formattedNumber;
    }
    return formattedNumber.replace(currency, correctedCurrency);
};

module.exports = {getCorrectedCurrencySymbol, getConsolidatedCurrencySymbols, CURRENCY_PRECISIONS, replaceWithHomeAwayCurrencySymbol};
